import { jsx as _jsx } from "react/jsx-runtime";

function SvgShop() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.048 8.51L4.688 4h14.6l1.729 4.755c.026.215-.01.551-.16.815-.123.218-.339.43-.87.43-1.454 0-1.951-.931-2.029-1.243a1 1 0 00-1.94 0 1.918 1.918 0 01-.46.797 1.42 1.42 0 01-1.07.446 1.42 1.42 0 01-1.07-.446 1.917 1.917 0 01-.46-.797 1 1 0 00-1.94 0 1.918 1.918 0 01-.46.797 1.42 1.42 0 01-1.07.446c-.554 0-.786-.157-.944-.32-.207-.215-.349-.5-.586-.976l-.076-.151a1 1 0 00-1.788 0C5.59 9.56 5.215 10 4.487 10c-.482 0-.823-.145-1.047-.34-.222-.193-.392-.49-.44-.919a.558.558 0 01.047-.23zM4.338 2a1.5 1.5 0 00-1.41.987l-1.76 4.84a2.51 2.51 0 00-.155 1.136c.098.874.477 1.65 1.115 2.206.288.25.616.445.972.582v9.182c0 1.087.88 1.967 1.966 1.967h13.867c1.086 0 1.967-.88 1.967-1.967v-9.051a2.77 2.77 0 001.698-1.327 3.398 3.398 0 00.37-2.251l-.014-.074-1.907-5.243A1.5 1.5 0 0019.637 2H4.339zM19.1 11.924a3.976 3.976 0 01-2.067-1.02c-.557.6-1.382 1.096-2.545 1.096-1.132 0-1.944-.47-2.5-1.048C11.43 11.53 10.62 12 9.488 12c-1.047 0-1.814-.343-2.382-.93a3.24 3.24 0 01-.154-.172c-.478.532-1.13.977-2.052 1.08v8.955c0 .092.074.167.166.167H8.1v-5.6a1.4 1.4 0 011.4-1.4h5a1.4 1.4 0 011.4 1.4v5.6h3.033a.167.167 0 00.167-.167v-9.01zM9.9 15.9v5.2h4.2v-5.2H9.9z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgShop;